export const fontFamily = {
  sans: 'Roboto, system-ui, -apple-system, "Segoe UI", sans-serif',
};

// Only 400/500/700 are actually loaded (next/font/google in apps/marketing,
// @fontsource/roboto in apps/app, @expo-google-fonts/roboto in apps/mobile)
// — a weight outside this set forces the browser/OS to synthesize (faux-bold)
// or silently substitute the nearest loaded weight. `semibold` keeps its
// existing name (still referenced by ~25 `font-semibold`/`fontWeight.semibold`
// call sites across both apps) but now resolves to 500 (Roboto Medium), not
// 600 — the closest loaded weight, and what M3's own type scale uses for
// this level of emphasis. `font-bold`/700 is unaffected — Tailwind's own
// built-in --font-weight-bold (700) was never overridden here, so it already
// resolves to a real loaded weight.
export const fontWeight = {
  normal: "400",
  semibold: "500",
};

export type FontSizeKey = "xs" | "sm" | "base" | "lg" | "xl" | "2xl" | "3xl";

interface ScaleEntry {
  fontSize: string;
  lineHeight: string;
}

export const fontSize: Record<FontSizeKey, ScaleEntry> = {
  xs: { fontSize: "0.75rem", lineHeight: "1rem" },
  sm: { fontSize: "0.875rem", lineHeight: "1.25rem" },
  base: { fontSize: "1rem", lineHeight: "1.5rem" },
  lg: { fontSize: "1.125rem", lineHeight: "1.75rem" },
  xl: { fontSize: "1.25rem", lineHeight: "1.75rem" },
  "2xl": { fontSize: "1.5rem", lineHeight: "2rem" },
  "3xl": { fontSize: "1.875rem", lineHeight: "2.25rem" },
};

// Applied via Text's `variant="figure"` — never left to be remembered per usage.
export const tabularNumsClass = "[font-variant-numeric:tabular-nums]";
